import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class IndividualVenueMultiSiteOnlyPopulateFromVenue extends VenueRegistrationFormModal {
	constructor() {
		super({
			wrapperSelector: '.p-individual-venue-multi-site-only',
			sectionWrapperSelector: '.p-individual-venue-multi-site-only-wrapper',
			modalSelector: '#js-individual-venue-populate-from-venue-form-modal',
			triggerSelectors: ['.js-individual-venue-populate-from-venue'],
			stepsEndpointAttr: 'populate-from-venue-steps-endpoint',
			submitEndpointAttr: 'populate-from-venue-submit-endpoint',
			logPrefix: 'IndividualVenueMultiSiteOnlyPopulateFromVenue'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: this.totalSteps,
			formType: FormTypes.StepForm,
			hasSeparator: true,
			isBackButtonEnabled: false,
			exitButtonClasses: 'lta-form-generator__form-exit-button--underlined',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Use venue to populate',
				classes: 'u-mt-4 u-mb-4'
			}
		};
	}
}

VenueRegistrationFormModal.boot(IndividualVenueMultiSiteOnlyPopulateFromVenue);

export default IndividualVenueMultiSiteOnlyPopulateFromVenue;
